import {
  aiCollapse,
  defaultIcon,
  emergencyInspection,
  residentialDamageInspection,
  residentialDamageInspectionAbove,
  residentialDamageInspectionUnder
} from '@/assets/img/buildingMarker/imageBase64'

/** 判定状況 */
export const JUDGEMENT_STATUS = {
  /** 判定済み */
  JUDGED: 'judged',
  /** 未判定：住家被害認定調査 */
  NOT_JUDGED_RESIDENTIAL_DAMAGE_INSPECTION: 'notJudgedResidentialDamageInspection',
  /** 未判定：AI倒壊判定 */
  NOT_JUDGED_AI_COLLAPSE_JUDGEMENT: 'notJudgedAiCollapseJudgement',
  /** 未判定：応急危険度判定調査 */
  NOT_JUDGED_EMERGENCY_INSPECTION: 'notJudgedEmergencyInspection'
} as const

/** 住家被害認定調査の凡例用ラベル（床なし） */
export const RESIDENTIAL_DAMAGE_LABELS = [
  {
    label: '未判定',
    name: 'icon_resi_n_uninvestigated',
    icon: `data:image/png;base64,${residentialDamageInspection.uninvestigated}`,
    color: '#9B9A99'
  },
  {
    label: '一部損壊',
    name: 'icon_resi_n_partiallyDamaged',
    icon: `data:image/png;base64,${residentialDamageInspection.partiallyDamaged}`,
    color: '#328CBE'
  },
  {
    label: '準半壊',
    name: 'icon_resi_n_semiPartiallyDestroyed',
    icon: `data:image/png;base64,${residentialDamageInspection.semiPartiallyDestroyed}`,
    color: '#77C1EA'
  },
  {
    label: '半壊',
    name: 'icon_resi_n_partiallyDestroyed',
    icon: `data:image/png;base64,${residentialDamageInspection.partiallyDestroyed}`,
    color: '#DC7C30'
  },
  {
    label: '中規模半壊',
    name: 'icon_resi_n_halfTotallyDestroyed',
    icon: `data:image/png;base64,${residentialDamageInspection.halfTotallyDestroyed}`,
    color: '#EAB030'
  },
  {
    label: '大規模半壊',
    name: 'icon_resi_n_almostTotallyDestroyed',
    icon: `data:image/png;base64,${residentialDamageInspection.almostTotallyDestroyed}`,
    color: '#D592B6'
  },
  {
    label: '全壊',
    name: 'icon_resi_n_totallyDestroyed',
    icon: `data:image/png;base64,${residentialDamageInspection.totallyDestroyed}`,
    color: '#DE574F'
  },
  {
    label: '床下浸水',
    name: 'icon_resi_floodingUnderFloor',
    icon: `data:image/png;base64,${residentialDamageInspection.floodingUnderFloor}`,
    color: '#000000'
  },
  {
    label: '床上浸水',
    name: 'icon_resi_floodingAboveFloor',
    icon: `data:image/png;base64,${residentialDamageInspection.floodingAboveFloor}`,
    color: '#000000'
  }
] as const

/** 住家被害認定調査の凡例用ラベル（浸水系なし） */
export const RESIDENTIAL_DAMAGE_LABELS_WITHOUT_FLOODING = RESIDENTIAL_DAMAGE_LABELS.filter(
  item =>
    item.name !== 'icon_resi_floodingUnderFloor' && item.name !== 'icon_resi_floodingAboveFloor'
)

/** 住家被害認定調査の凡例用ラベル（床下） */
export const RESIDENTIAL_DAMAGE_UNDER_LABELS = [
  {
    label: '未判定（床下）',
    name: 'icon_resi_u_uninvestigated',
    icon: `data:image/png;base64,${residentialDamageInspectionUnder.uninvestigated}`,
    color: '#9B9A99'
  },
  {
    label: '一部損壊（床下）',
    name: 'icon_resi_u_partiallyDamaged',
    icon: `data:image/png;base64,${residentialDamageInspectionUnder.partiallyDamaged}`,
    color: '#328CBE'
  },
  {
    label: '準半壊（床下）',
    name: 'icon_resi_u_semiPartiallyDestroyed',
    icon: `data:image/png;base64,${residentialDamageInspectionUnder.semiPartiallyDestroyed}`,
    color: '#77C1EA'
  },
  {
    label: '半壊（床下）',
    name: 'icon_resi_u_partiallyDestroyed',
    icon: `data:image/png;base64,${residentialDamageInspectionUnder.partiallyDestroyed}`,
    color: '#DC7C30'
  },
  {
    label: '中規模半壊（床下）',
    name: 'icon_resi_u_halfTotallyDestroyed',
    icon: `data:image/png;base64,${residentialDamageInspectionUnder.halfTotallyDestroyed}`,
    color: '#EAB030'
  },
  {
    label: '大規模半壊（床下）',
    name: 'icon_resi_u_almostTotallyDestroyed',
    icon: `data:image/png;base64,${residentialDamageInspectionUnder.almostTotallyDestroyed}`,
    color: '#D592B6'
  },
  {
    label: '全壊（床下）',
    name: 'icon_resi_u_totallyDestroyed',
    icon: `data:image/png;base64,${residentialDamageInspectionUnder.totallyDestroyed}`,
    color: '#DE574F'
  }
] as const

/** 住家被害認定調査の凡例用ラベル（床なし） */
export const RESIDENTIAL_DAMAGE_ABOVE_LABELS = [
  {
    label: '未判定（床上）',
    name: 'icon_resi_a_uninvestigated',
    icon: `data:image/png;base64,${residentialDamageInspectionAbove.uninvestigated}`,
    color: '#9B9A99'
  },
  {
    label: '一部損壊（床上）',
    name: 'icon_resi_a_partiallyDamaged',
    icon: `data:image/png;base64,${residentialDamageInspectionAbove.partiallyDamaged}`,
    color: '#328CBE'
  },
  {
    label: '準半壊',
    name: 'icon_resi_a_semiPartiallyDestroyed',
    icon: `data:image/png;base64,${residentialDamageInspectionAbove.semiPartiallyDestroyed}`,
    color: '#77C1EA'
  },
  {
    label: '半壊（床上）',
    name: 'icon_resi_a_partiallyDestroyed',
    icon: `data:image/png;base64,${residentialDamageInspectionAbove.partiallyDestroyed}`,
    color: '#DC7C30'
  },
  {
    label: '中規模半壊（床上）',
    name: 'icon_resi_a_halfTotallyDestroyed',
    icon: `data:image/png;base64,${residentialDamageInspectionAbove.halfTotallyDestroyed}`,
    color: '#EAB030'
  },
  {
    label: '大規模半壊（床上）',
    name: 'icon_resi_a_almostTotallyDestroyed',
    icon: `data:image/png;base64,${residentialDamageInspectionAbove.almostTotallyDestroyed}`,
    color: '#D592B6'
  },
  {
    label: '全壊（床上）',
    name: 'icon_resi_a_totallyDestroyed',
    icon: `data:image/png;base64,${residentialDamageInspectionAbove.totallyDestroyed}`,
    color: '#DE574F'
  }
] as const

/** 応急危険度判定の凡例用ラベル */
export const EMERGENCY_LABELS = [
  {
    label: '未判定',
    name: 'icon_eme_uninvestigated',
    icon: `data:image/png;base64,${emergencyInspection.uninvestigated}`,
    color: '#9B9A99'
  },
  {
    label: '調査済み',
    name: 'icon_eme_inspected',
    icon: `data:image/png;base64,${emergencyInspection.inspected}`,
    color: '#14AE5C'
  },
  {
    label: '要注意',
    name: 'icon_eme_warning',
    icon: `data:image/png;base64,${emergencyInspection.warning}`,
    color: '#EAB030'
  },
  {
    label: '危険',
    name: 'icon_eme_danger',
    icon: `data:image/png;base64,${emergencyInspection.danger}`,
    color: '#DE574F'
  }
] as const

/** AI倒壊判定の凡例用ラベル */
export const AI_COLLAPSE_LABELS = [
  {
    label: '未判定',
    name: 'icon_ai_uninvestigated',
    icon: `data:image/png;base64,${aiCollapse.uninvestigated}`,
    color: '#9B9A99'
  },
  {
    label: '非全壊',
    name: 'icon_ai_notTotallyDestroyed',
    icon: `data:image/png;base64,${aiCollapse.notTotallyDestroyed}`,
    color: '#328CBE'
  },
  {
    label: '全壊',
    name: 'icon_ai_totalCollapse',
    icon: `data:image/png;base64,${aiCollapse.totalCollapse}`,
    color: '#DE574F'
  }
] as const

/** デフォルトアイコン */
export const DEFAULT_LABELS = [
  {
    name: 'icon_default',
    icon: `data:image/png;base64,${defaultIcon}`
  }
] as const
